import React from "react";
import {
  Alert,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal,
  Row,
  Col,
  Spinner,
  Container,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AuthHeader from "components/Headers/AuthHeader.js";

export default function PaymentCallback() {
  const { result } = useParams();
  console.log(result);
  React.useEffect(() => {}, []);
  return (
    <>
      <AuthHeader title="" lead="" deviceType={false} />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary shadow border-0">
              <CardHeader className="bg-transparent">
                <div className="text-center">
                  <img
                    alt="..."
                    style={{ maxHeight: "200px" }}
                    src={require("assets/img/brand/biteLogrLogos/LOGO.png")}
                  />
                </div>
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-3">
                {result === "success" ? (
                  <Alert color="success">
                    <strong>Successfully Subscribed!</strong> Return to the
                    BiteLogr App!
                  </Alert>
                ) : (
                  <Alert color="warning">
                    <strong>Fail</strong> Payment canceled or errored. Return to
                    the app and try again!
                  </Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
